"use client";

import { useState } from "react";
import ReportsPLPage from "./ReportsPLPage";
import ReportsBalanceSheetPage from "./ReportsBalanceSheetPage";
import { NaturalLanguageReports } from "@/components/ai/NaturalLanguageReports";
import PageSkeleton from "./PageSkeleton";

type ReportType = "pl" | "balance-sheet";

export default function ReportsShell() {
  const [report, setReport] = useState<ReportType>("pl");

  return (
    <div className="p-6 lg:p-8 space-y-6">
      {/* Report type selector */}
      <div className="flex items-center gap-3">
        <div>
          <h1 className="text-3xl font-serif font-bold text-gray-900">Reports</h1>
          <p className="text-gray-500 mt-1">Financial statements and analysis</p>
        </div>
      </div>

      <div className="flex gap-1 bg-gray-100 rounded-lg p-1 w-fit">
        {([
          { key: "pl" as ReportType, label: "Profit & Loss" },
          { key: "balance-sheet" as ReportType, label: "Balance Sheet" },
        ]).map((r) => (
          <button
            key={r.key}
            onClick={() => setReport(r.key)}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-all cursor-pointer ${
              report === r.key
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-500 hover:text-gray-700"
            }`}
          >
            {r.label}
          </button>
        ))}
      </div>

      {report === "pl" && <ReportsPLPage />}
      {report === "balance-sheet" && <ReportsBalanceSheetPage />}
    </div>
  );
}
